<ng-select
  [items]="displayedMealTicketsOptions"
  [ngClass]="{ 'fixed-width-style': !!fixWidth }"
  [style.width.px]="fixWidth"
  [style.max-width.px]="fixWidth"
  [attr.aria-label]="ariaLabel"
  [searchable]="false"
  [clearable]="clearable"
  [placeholder]="placeHolder | translate"
  [(ngModel)]="selectedQuantity"
  (change)="setCurrentMealTicketsNumber($event)"
  appendTo="body"
  appNgSelectAriaControl>
</ng-select>
